import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.chat');
import { OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { getStatusColor } from "src/libs/portal/metaverse/types";
import 'emoji-picker-element';

interface ChatMessage {
    sid: string;
    userId?: string;
    nickname: string;
    message: string;
    color: string;
    timestamp: number;
    type?: string;
    scope?: string;
    noUnread?: boolean;
}

@Component({
    selector: 'wiz-component-chat',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.chat/view.scss */
:host {
  display: block;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 30;
  pointer-events: none;
  width: 0;
}

.chat-fab {
  box-shadow: 0 0.25rem 0.875rem rgba(0, 0, 0, 0.25);
}
.chat-fab:hover {
  box-shadow: 0 0.375rem 1.25rem rgba(0, 0, 0, 0.3);
}

.chat-panel {
  animation: chatFadeIn 0.2s ease-out;
}

.chat-panel-closing {
  animation: chatFadeOut 0.2s ease-in forwards;
}

@keyframes chatFadeIn {
  from {
    opacity: 0;
    transform: translateX(1.25rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes chatFadeOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(1.25rem);
  }
}
.postit-wiggle {
  animation: wiggle 0.6s ease-in-out 3;
}

@keyframes wiggle {
  0%, 100% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-0.375rem);
  }
  40% {
    transform: translateX(0.25rem);
  }
  60% {
    transform: translateX(-0.1875rem);
  }
  80% {
    transform: translateX(0.125rem);
  }
}
.user-list-content {
  animation: userListSlide 0.2s ease-out;
}

@keyframes userListSlide {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 10rem;
  }
}
.user-list-item {
  animation: userItemFadeIn 0.15s ease-out both;
}

.user-list-item:nth-child(1) {
  animation-delay: 30ms;
}

.user-list-item:nth-child(2) {
  animation-delay: 60ms;
}

.user-list-item:nth-child(3) {
  animation-delay: 90ms;
}

.user-list-item:nth-child(4) {
  animation-delay: 120ms;
}

.user-list-item:nth-child(5) {
  animation-delay: 150ms;
}

.user-list-item:nth-child(6) {
  animation-delay: 180ms;
}

.user-list-item:nth-child(7) {
  animation-delay: 210ms;
}

.user-list-item:nth-child(8) {
  animation-delay: 240ms;
}

.user-list-item:nth-child(9) {
  animation-delay: 270ms;
}

.user-list-item:nth-child(10) {
  animation-delay: 300ms;
}

.user-list-item:nth-child(11) {
  animation-delay: 330ms;
}

.user-list-item:nth-child(12) {
  animation-delay: 360ms;
}

.user-list-item:nth-child(13) {
  animation-delay: 390ms;
}

.user-list-item:nth-child(14) {
  animation-delay: 420ms;
}

.user-list-item:nth-child(15) {
  animation-delay: 450ms;
}

.user-list-item:nth-child(16) {
  animation-delay: 480ms;
}

.user-list-item:nth-child(17) {
  animation-delay: 510ms;
}

.user-list-item:nth-child(18) {
  animation-delay: 540ms;
}

.user-list-item:nth-child(19) {
  animation-delay: 570ms;
}

.user-list-item:nth-child(20) {
  animation-delay: 600ms;
}

@keyframes userItemFadeIn {
  from {
    opacity: 0;
    transform: translateX(-0.5rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@media (max-width: 768px) {
  .chat-fab {
    width: 3rem !important;
    height: 3rem !important;
  }
  .chat-panel {
    width: 17.5rem !important;
  }
}`],
})
export class ComponentChatComponent implements OnInit, OnDestroy {
    @Input() myNickname: string = '';
    @Input() mySid: string = '';
    @Input() myUserId: string = '';
    @Input() players: any = {};
    @Input() typingPlayers: { [sid: string]: string } = {};
    @Input() currentRoom: string = '';
    @Output() messageSend = new EventEmitter<string>();
    @Output() globalMessageSend = new EventEmitter<string>();
    @Output() whisperSend = new EventEmitter<{ targetNickname: string, message: string }>();
    @Output() typingStart = new EventEmitter<void>();
    @Output() typingStop = new EventEmitter<void>();
    @Output() chatToggle = new EventEmitter<boolean>();
    @Output() whisperTargetRequest = new EventEmitter<void>();

    @ViewChild('chatMessagesContainer') chatMessagesRef!: ElementRef<HTMLDivElement>;
    @ViewChild('chatInput') chatInputRef!: ElementRef<HTMLInputElement>;
    @ViewChild('modeDropdownBtn') modeDropdownBtnRef!: ElementRef<HTMLButtonElement>;

    constructor(@Inject( Service) public service: Service) { }

    private _messages: ChatMessage[] = [];

    @Input() set messages(val: ChatMessage[]) {
        const prevLen = this._messages?.length || 0;
        this._messages = val || [];
        const newMessages = this._messages.slice(prevLen);
        if (newMessages.length > 0) {
            if (!this.isOpen) {
                const countable = newMessages.filter(m => !m.noUnread);
                this.unreadCount += countable.length;
                if (countable.length > 0) this.triggerBadgeWiggle();
            }
            setTimeout(() => this.scrollToBottom(), 50);
        }
    }
    get messages(): ChatMessage[] { return this._messages; }

    private _whisperTarget: any = null;
    @Input() set whisperTarget(val: any) {
        if (val && val.nickname) {
            this._whisperTarget = val;
            this.chatMode = 'whisper';
            this.whisperTargetNickname = val.nickname;
            this.isOpen = true;
            this.unreadCount = 0;
            this.chatToggle.emit(true);
            setTimeout(async () => {
                if (this.chatInputRef?.nativeElement) {
                    this.chatInputRef.nativeElement.focus();
                }
                this.scrollToBottom();
                await this.service.render();
            }, 100);
        }
    }

    public isOpen: boolean = false;
    public isChatClosing: boolean = false;
    public showUserList: boolean = false;
    public inputText: string = '';
    public maxLength: number = 150;
    public unreadCount: number = 0;
    public badgeWiggle: boolean = false;
    private badgeWiggleTimeout: any = null;

    // 채팅 모드: all(전체), center(센터), whisper(귓속말)
    public chatMode: 'all' | 'center' | 'whisper' = 'center';
    public whisperTargetNickname: string = '';
    public showModeDropdown: boolean = false;

    // 이모지 피커
    public showEmojiPicker: boolean = false;
    @ViewChild('emojiPickerContainer') emojiPickerContainerRef!: ElementRef<HTMLDivElement>;
    private emojiPickerEl: any = null;
    private emojiClickHandler: any = null;

    // 타이핑 감지
    private typingTimer: any = null;
    private isTypingEmitted: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public ngOnDestroy() {
        this.destroyEmojiPicker();
        if (this.typingTimer) {
            clearTimeout(this.typingTimer);
            this.typingStop.emit();
        }
        if (this.badgeWiggleTimeout) clearTimeout(this.badgeWiggleTimeout);
    }

    public triggerBadgeWiggle() {
        this.badgeWiggle = false;
        this.service.render();
        if (this.badgeWiggleTimeout) clearTimeout(this.badgeWiggleTimeout);
        setTimeout(() => {
            this.badgeWiggle = true;
            this.service.render();
            this.badgeWiggleTimeout = setTimeout(() => {
                this.badgeWiggle = false;
                this.service.render();
            }, 700);
        }, 10);
    }

    // === 드롭다운 바깥 클릭 감지 ===

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (!this.showModeDropdown) return;
        const target = event.target as HTMLElement;
        if (this.modeDropdownBtnRef?.nativeElement?.contains(target)) return;
        this.showModeDropdown = false;
        this.service.render();
    }

    // === 채팅 패널 wheel/touch 이벤트 전파 차단 ===

    public onPanelWheel(event: WheelEvent) {
        event.stopPropagation();
    }

    public onPanelTouchMove(event: TouchEvent) {
        event.stopPropagation();
    }

    // === 채팅 모드 ===

    public async toggleModeDropdown(event?: MouseEvent) {
        if (event) event.stopPropagation();
        this.showModeDropdown = !this.showModeDropdown;
        await this.service.render();
    }

    public async selectMode(mode: 'all' | 'center' | 'whisper', event?: MouseEvent) {
        if (event) event.stopPropagation();
        this.showModeDropdown = false;
        if (mode === 'whisper') {
            if (!this.whisperTargetNickname) {
                this.whisperTargetRequest.emit();
            } else {
                this.chatMode = 'whisper';
            }
        } else {
            this.chatMode = mode;
            if (mode !== 'whisper') {
                this.whisperTargetNickname = '';
                this._whisperTarget = null;
            }
        }
        await this.service.render();
    }

    public async clearWhisperMode() {
        this.chatMode = 'center';
        this.whisperTargetNickname = '';
        this._whisperTarget = null;
        await this.service.render();
    }

    public async replyWhisper(nickname: string) {
        this.chatMode = 'whisper';
        this.whisperTargetNickname = nickname;
        this._whisperTarget = { nickname };
        this.isOpen = true;
        this.unreadCount = 0;
        this.chatToggle.emit(true);
        await this.service.render();
        setTimeout(() => { this.chatInputRef?.nativeElement?.focus(); }, 100);
    }

    // === Emoji ===

    public async onEmojiSelect(emoji: string) {
        if (this.inputText.length + emoji.length <= this.maxLength) {
            this.inputText += emoji;
            if (this.chatInputRef?.nativeElement) {
                this.chatInputRef.nativeElement.value = this.inputText;
                this.chatInputRef.nativeElement.focus();
            }
        }
        await this.service.render();
    }

    // === Chat toggle ===

    public async toggleChat() {
        if (this.isOpen) {
            this.isChatClosing = true;
            this.showEmojiPicker = false;
            this.showModeDropdown = false;
            this.chatToggle.emit(false);
            await this.service.render();
            setTimeout(async () => {
                this.isOpen = false;
                this.isChatClosing = false;
                await this.service.render();
            }, 200);
        } else {
            this.isOpen = true;
            this.showEmojiPicker = false;
            this.showModeDropdown = false;
            this.chatToggle.emit(true);
            this.unreadCount = 0;
            await this.service.render();
            setTimeout(() => {
                this.scrollToBottom();
                if (this.chatInputRef?.nativeElement) {
                    this.chatInputRef.nativeElement.focus();
                }
            }, 100);
        }
    }

    public async toggleUserList() {
        this.showUserList = !this.showUserList;
        await this.service.render();
    }

    public async toggleEmojiPicker() {
        this.showEmojiPicker = !this.showEmojiPicker;
        this.showModeDropdown = false;
        await this.service.render();
        if (this.showEmojiPicker) {
            setTimeout(() => this.createEmojiPicker(), 0);
        } else {
            this.destroyEmojiPicker();
        }
    }

    private createEmojiPicker() {
        if (!this.emojiPickerContainerRef?.nativeElement) return;
        this.destroyEmojiPicker();
        const picker = document.createElement('emoji-picker') as any;
        picker.style.width = '100%';
        picker.style.height = '100%';
        picker.style.setProperty('--num-columns', '8');
        picker.style.setProperty('--emoji-size', '1.25rem');
        picker.style.setProperty('--border-size', '0');
        picker.style.setProperty('--background', '#ffffff');
        picker.style.setProperty('--category-emoji-size', '1.125rem');
        picker.style.setProperty('--indicator-color', '#6366f1');
        picker.style.setProperty('--input-border-color', '#e5e7eb');
        picker.style.setProperty('--outline-color', '#6366f1');
        this.emojiClickHandler = (event: any) => {
            const emoji = event.detail?.unicode;
            if (emoji) this.onEmojiSelect(emoji);
        };
        picker.addEventListener('emoji-click', this.emojiClickHandler);
        this.emojiPickerContainerRef.nativeElement.appendChild(picker);
        this.emojiPickerEl = picker;
    }

    private destroyEmojiPicker() {
        if (this.emojiPickerEl) {
            if (this.emojiClickHandler) {
                this.emojiPickerEl.removeEventListener('emoji-click', this.emojiClickHandler);
            }
            this.emojiPickerEl.remove();
            this.emojiPickerEl = null;
            this.emojiClickHandler = null;
        }
    }

    // === Send ===

    public async sendMessage() {
        const text = this.inputText.trim();
        if (!text) return;

        const whisperMatch = text.match(/^\/[wㅈ]\s+(\S+)\s+(.+)$/);
        if (whisperMatch) {
            this.whisperSend.emit({ targetNickname: whisperMatch[1], message: whisperMatch[2] });
        } else if (this.chatMode === 'whisper' && this.whisperTargetNickname) {
            this.whisperSend.emit({ targetNickname: this.whisperTargetNickname, message: text });
        } else if (this.chatMode === 'all') {
            this.globalMessageSend.emit(text);
        } else {
            this.messageSend.emit(text);
        }

        this.inputText = '';
        this.showEmojiPicker = false;
        this.showModeDropdown = false;
        if (this.chatInputRef?.nativeElement) {
            this.chatInputRef.nativeElement.value = '';
        }

        // 타이핑 중지
        if (this.typingTimer) clearTimeout(this.typingTimer);
        this.isTypingEmitted = false;
        this.typingStop.emit();

        await this.service.render();
        setTimeout(() => this.scrollToBottom(), 50);
    }

    private isComposing: boolean = false;

    public onCompositionStart() {
        this.isComposing = true;
    }

    public onCompositionEnd(event: any) {
        this.isComposing = false;
        this.onInput(event);
    }

    public onKeyDown(event: KeyboardEvent) {
        event.stopPropagation();
        if (event.key === 'Enter' && !event.shiftKey && !this.isComposing) {
            event.preventDefault();
            this.sendMessage();
        }
    }

    private isWhisperInput(text: string): boolean {
        return /^\/[wㅈ]\s/.test(text) || /^\/[wㅈ]$/.test(text);
    }

    public async onInput(event: any) {
        const value = event.target.value || '';
        if (value.length <= this.maxLength) {
            this.inputText = value;
        } else {
            this.inputText = value.slice(0, this.maxLength);
            event.target.value = this.inputText;
        }

        this.showModeDropdown = false;
        await this.service.render();

        const trimmed = this.inputText.trim();
        const isWhisper = this.isWhisperInput(trimmed) || this.chatMode === 'whisper';

        // 타이핑 감지: 귓속말 입력 시에는 타이핑 이벤트를 발생시키지 않음
        if (trimmed.length > 0 && !isWhisper) {
            if (!this.isTypingEmitted) {
                this.isTypingEmitted = true;
                this.typingStart.emit();
            }
            if (this.typingTimer) clearTimeout(this.typingTimer);
            this.typingTimer = setTimeout(() => {
                this.isTypingEmitted = false;
                this.typingStop.emit();
            }, 2000);
        } else {
            // 빈 입력이거나 귓속말 입력인 경우: 타이핑 중이었으면 즉시 중지
            if (this.isTypingEmitted) {
                this.isTypingEmitted = false;
                if (this.typingTimer) clearTimeout(this.typingTimer);
                this.typingStop.emit();
            }
        }
    }

    // === Player lists ===

    public getPlayerList(): any[] {
        return Object.values(this.players || {});
    }

    public get activeOnlineCount(): number {
        return this.getPlayerList().length;
    }

    public get onlineCount(): number {
        return Object.keys(this.players || {}).length;
    }

    public get typingNicknames(): string[] {
        return Object.values(this.typingPlayers || {});
    }

    private scrollToBottom() {
        if (this.chatMessagesRef?.nativeElement) {
            const el = this.chatMessagesRef.nativeElement;
            el.scrollTop = el.scrollHeight;
        }
    }

    public getTimeString(timestamp: number): string {
        const date = new Date(timestamp);
        return date.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    }

    public getMsgStatusColor(msg: ChatMessage): string {
        let player = this.players[msg.sid];
        if (!player && msg.userId) {
            for (const p of Object.values(this.players || {})) {
                if ((p as any).userId && (p as any).userId === msg.userId) {
                    player = p;
                    break;
                }
            }
        }
        if (!player) {
            for (const p of Object.values(this.players || {})) {
                if ((p as any).userId && (p as any).userId === msg.sid) {
                    player = p;
                    break;
                }
            }
        }
        return getStatusColor(player?.status || 'out');
    }

    public isWhisper(msg: ChatMessage): boolean {
        return msg.type === 'whisper';
    }

    public isPoke(msg: ChatMessage): boolean {
        return msg.type === 'poke';
    }

    public isSystem(msg: ChatMessage): boolean {
        return msg.sid === 'system';
    }

    public isGlobal(msg: ChatMessage): boolean {
        return msg.scope === 'global';
    }

    public isMyMessage(msg: ChatMessage): boolean {
        if (msg.userId && this.myUserId) return msg.userId === this.myUserId;
        return msg.sid === this.mySid;
    }

    public getModeIcon(): string {
        if (this.chatMode === 'all') return 'fa-solid fa-globe';
        if (this.chatMode === 'whisper') return 'fa-regular fa-comment-dots';
        return 'fa-solid fa-building';
    }

    public get centerPlaceholder(): string {
        const room = this.currentRoom;
        if (room === 'solution') return '솔루션센터에 메시지...';
        if (room === 'research') return '연구센터에 메시지...';
        return '해당 센터에 메시지...';
    }
}

export default ComponentChatComponent;